export const LOGO_URL = "https://customer-assets.emergentagent.com/job_push2stream-redesign/artifacts/956q4u3d_push%202%20Logo.png";
export const ICON_URL = "https://customer-assets.emergentagent.com/job_push2stream-redesign/artifacts/j5dg567v_push%20icon%202.png";
export const FAVICON_URL = "https://customer-assets.emergentagent.com/job_push2stream-redesign/artifacts/coq5tzgj_push%20favicon.png";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Solutions", to: "/solutions" },
  { label: "Clients", to: "/clients" },
  { label: "Pricing", to: "/pricing" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: "120+", label: "Channels powered" },
  { value: "9", label: "Connected platforms" },
  { value: "99.99%", label: "Streaming uptime" },
  { value: "40+", label: "Countries served" },
];

export const PLATFORMS = [
  { name: "Roku" },
  { name: "Apple TV" },
  { name: "Fire TV" },
  { name: "Android TV" },
  { name: "Samsung Tizen" },
  { name: "LG webOS" },
  { name: "iOS" },
  { name: "Android" },
  { name: "Web" },
];

export const SERVICES = [
  {
    slug: "tv-apps",
    title: "Native TV Apps",
    summary: "Beautiful, certified apps for Roku, Apple TV, Fire TV, Samsung, LG and Android TV — built to your brand.",
    bullets: ["Channel store submission", "Custom UI / UX", "Universal search & deep linking", "Voice remote support"],
  },
  {
    slug: "mobile-web-apps",
    title: "Mobile & Web Apps",
    summary: "iOS, Android and responsive web experiences with offline downloads, casting and adaptive playback.",
    bullets: ["Native iOS & Android", "Progressive web app", "Chromecast & AirPlay", "Offline downloads"],
  },
  {
    slug: "live-streaming",
    title: "Live Streaming + CDN",
    summary: "Carrier-grade ingest and global CDN delivery in SD, HD, 4K and beyond — engineered to never buffer.",
    bullets: ["Multi-bitrate ingest", "Global edge CDN", "Adaptive bitrate playback", "Low-latency HLS / LL-DASH"],
  },
  {
    slug: "cloud-playout",
    title: "Cloud Playout — MoxyPlay",
    summary: "A linear TV channel in a box. Schedule playlists, overlay graphics and go live from your browser.",
    bullets: ["Drag-and-drop scheduler", "Logo, ticker, crawl, clock", "EAS / emergency overrides", "Multi-channel control"],
  },
  {
    slug: "transcoding",
    title: "Transcoding & Packaging",
    summary: "Convert anything to anything. We mezzanine, transcode and package to every codec and DRM your audience needs.",
    bullets: ["H.264 / HEVC / AV1", "HLS, DASH, CMAF", "Widevine, FairPlay, PlayReady", "Audio normalization"],
  },
  {
    slug: "dvr-catchup",
    title: "DVR / Catchup / Live-to-VOD",
    summary: "Auto-record every linear channel. Viewers rewind, pause and binge — instantly, on any device.",
    bullets: ["Cloud DVR storage", "Rolling catchup window", "Auto live-to-VOD", "Per-program clipping"],
  },
  {
    slug: "monetization",
    title: "Monetization",
    summary: "AVOD, SVOD, TVOD, pay-per-view, donations and ads — mix any model, manage every dollar.",
    bullets: ["Subscriptions & pay-per-view", "Server-side ad insertion (SSAI)", "Coupons & promo codes", "Stripe, PayPal, CinetPay"],
  },
  {
    slug: "analytics",
    title: "Analytics & Insights",
    summary: "Real-time and historical viewership, revenue and bandwidth — broken down by device, region and content.",
    bullets: ["Concurrent viewers live", "Geo & device breakdown", "Revenue & churn reports", "API & data exports"],
  },
  {
    slug: "content-protection",
    title: "Content Protection",
    summary: "Stop piracy at the source. DRM, token auth, watermarking and geo-blocking — out of the box.",
    bullets: ["Studio-grade DRM", "Forensic watermarking", "Token-based playback", "Geo & domain locks"],
  },
];

export const SOLUTIONS = [
  {
    slug: "ott-iptv-operators",
    title: "OTT & IPTV Operators",
    description:
      "Spin up a multi-channel pay-TV service across every screen — without owning a server rack. We power your subscriber experience end-to-end so you can focus on programming and growth.",
    points: ["End-to-end OTT/IPTV stack", "Subscriber & billing automation", "Multi-tenant white-label", "24/7 NOC monitoring"],
  },
  {
    slug: "broadcasters",
    title: "Broadcasters & Media Networks",
    description:
      "Extend your linear channels to digital audiences with cloud playout, live-to-VOD and native TV apps. Keep your brand, your control room and your ad inventory intact.",
    points: ["Cloud playout & graphics", "Ad replacement (DAI/SSAI)", "Captions & accessibility", "SCTE-35 ad signaling"],
  },
  {
    slug: "faith-community",
    title: "Faith & Community Networks",
    description:
      "Bring your services, sermons and community events to every TV and phone in your congregation — with donation-ready monetization built in.",
    points: ["Donation & tithing flows", "Multi-language captions", "Service archives & catchup", "Watch parties"],
  },
  {
    slug: "sports-events",
    title: "Sports & Live Events",
    description:
      "Ultra-low-latency streaming, pay-per-view ticketing, multi-angle replays and DVR for fans who don't tolerate buffering.",
    points: ["Low-latency LL-HLS", "PPV ticketing & DRM", "Multi-cam & alt-angles", "Real-time stats overlays"],
  },
  {
    slug: "creators-studios",
    title: "Creators & Studios",
    description:
      "Turn your catalog into a branded streaming destination. SVOD, AVOD, rentals — your library, your rules, your revenue.",
    points: ["Branded apps in 4 weeks", "AVOD + SVOD + TVOD", "Audience-grade analytics", "Multi-currency checkout"],
  },
  {
    slug: "enterprise-corporate",
    title: "Enterprise & Corporate TV",
    description:
      "Internal town halls, training libraries, employee communications — secured, geo-fenced and SSO-integrated for global teams.",
    points: ["SSO / SAML auth", "Geo & IP restrictions", "Internal video portals", "Audit logs & compliance"],
  },
];

export const PARTNERS = [
  "AWS", "Akamai", "Wowza", "Flussonic", "Verizon", "Lumen", "Google Cloud", "Chargebee", "Zoho", "CinetPay", "Stripe", "Cloudflare"
];

export const PRICING = [
  {
    name: "Starter",
    tagline: "For solo creators launching their first stream",
    price: "$499",
    period: "/month",
    features: [
      "1 native TV app (Roku or Fire TV)",
      "Up to 5,000 monthly viewers",
      "1 live channel + VOD library",
      "Cloud playout (MoxyPlay Lite)",
      "Standard CDN, HD streaming",
      "AVOD or single-tier SVOD",
      "Email support",
    ],
    cta: "Start free trial",
    highlighted: false,
  },
  {
    name: "Growth",
    tagline: "For channels scaling across every screen",
    price: "$1,899",
    period: "/month",
    features: [
      "5 TV apps + iOS, Android & web",
      "Up to 100,000 monthly viewers",
      "10 live channels + unlimited VOD",
      "Cloud playout (MoxyPlay Pro)",
      "Global CDN with 4K + adaptive bitrate",
      "AVOD + SVOD + TVOD + PPV",
      "DRM + forensic watermarking",
      "Priority Slack support",
    ],
    cta: "Talk to sales",
    highlighted: true,
  },
  {
    name: "Enterprise",
    tagline: "Carrier-grade, multi-region, white-label",
    price: "Custom",
    period: "",
    features: [
      "Unlimited apps & white-label",
      "Unlimited viewers & channels",
      "Dedicated cloud playout cluster",
      "Multi-region CDN + private POPs",
      "Custom DRM, SSAI, ad partnerships",
      "SSO / SAML / SCIM",
      "Dedicated CSM + 24/7 NOC",
      "99.99% SLA",
    ],
    cta: "Contact sales",
    highlighted: false,
  },
];

export const PROJECTS = [
  {
    title: "Coaching & Fitness Network",
    category: "Health & Fitness",
    blurb: "Multi-platform OTT for a coaching brand — Roku, Fire TV, iOS and web with SVOD + cohort-based live classes.",
    image: "https://images.pexels.com/photos/4348093/pexels-photo-4348093.jpeg",
  },
  {
    title: "Pan-African News Channel",
    category: "News & Broadcast",
    blurb: "24/7 linear playout across 14 countries with French/English captions, ad replacement and a custom Roku app.",
    image: "https://images.pexels.com/photos/3944454/pexels-photo-3944454.jpeg",
  },
  {
    title: "Faith Community Network",
    category: "Faith & Community",
    blurb: "Sunday services, archives and donations across every TV — with a Spanish-language secondary channel.",
    image: "https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg",
  },
  {
    title: "Independent Film Studio",
    category: "Film & Studios",
    blurb: "Branded SVOD destination with TVOD rentals, DRM, watermarking and a hand-built Apple TV experience.",
    image: "https://images.pexels.com/photos/7991379/pexels-photo-7991379.jpeg",
  },
  {
    title: "Live Sports League",
    category: "Sports & Events",
    blurb: "Sub-3-second latency live streaming, PPV ticketing and multi-angle replays for a regional sports league.",
    image: "https://images.pexels.com/photos/1308713/pexels-photo-1308713.jpeg",
  },
  {
    title: "Enterprise Internal TV",
    category: "Enterprise",
    blurb: "Geo-restricted, SSO-authenticated corporate video portal for a 40,000-employee multinational.",
    image: "https://images.pexels.com/photos/3184293/pexels-photo-3184293.jpeg",
  },
];

export const FAQS = [
  {
    q: "How fast can we launch?",
    a: "Starter customers go live in under two weeks. Growth tier launches typically ship in four to six weeks, including TV app store approvals. Enterprise rollouts vary based on integrations.",
  },
  {
    q: "Do we own our apps and content?",
    a: "Yes — completely. Every app we build ships under your developer accounts on your stores. Your content lives in your storage. We never lock you in.",
  },
  {
    q: "Which monetization models do you support?",
    a: "All of them. AVOD, SVOD, TVOD, pay-per-view, donations, ad-supported with SSAI, hybrid models and bundle subscriptions — mix and match as you scale.",
  },
  {
    q: "What's included in your CDN?",
    a: "Adaptive bitrate delivery, global edge POPs, HTTPS + token authentication, geo-fencing and detailed bandwidth analytics. Growth and Enterprise tiers include 4K and low-latency HLS.",
  },
  {
    q: "Can you integrate with our existing billing / CRM?",
    a: "Yes — we ship native integrations with Stripe, PayPal, Chargebee, Zoho, CinetPay and most major identity providers. Custom integrations are part of Enterprise.",
  },
  {
    q: "What about content protection?",
    a: "Every plan includes token-based playback authentication. Growth adds studio-grade DRM (Widevine, FairPlay, PlayReady). Enterprise unlocks forensic watermarking and custom DRM negotiations.",
  },
];
